import * as MobxReact from "mobx-react";
import allStoresSingleton, {loadStores, StoreContext} from "../../components/stores/StoreLoader";
import {ExecutionEnvironment} from '../../components/stores/InterfaceStore';
import JSONWebToken from '../../components/utils/JSONWebToken';
import URI from "urijs";
import Router from 'next/router';
import {useContext} from "react";

export default function getAllStores() {
    let allStores;
    if (ExecutionEnvironment.canUseDOM) {
        MobxReact.enableStaticRendering(false);
        // we don't want to create a new set of stores every time we call this function, and we can't use the singleton
        // on the server because the singleton is global across all instances of the server/all requests
        allStores = allStoresSingleton;
    } else {
        MobxReact.enableStaticRendering(true);
        allStores = loadStores();
    }

    return allStores;
}

export async function useJwt(currentFullUrl, pathname) { // json web token
    const {userStore, interfaceStore} = useContext(StoreContext);
    const currentFullUrlParts = URI(currentFullUrl);

    if (currentFullUrlParts.hasQuery('jwt') && ExecutionEnvironment.canUseDOM) {
        const query = currentFullUrlParts.query(true);
        const jwt = new JSONWebToken();
        const token = jwt.decode(query.jwt);
        userStore.updateUser(token.user);

        // update the query string to remove jwt
        currentFullUrl = currentFullUrlParts.removeQuery('jwt').toString();
        await Router.replace(pathname);
    }

    // Set/store our current full URL in interfaceStore so that we can use it anywhere in the app
    interfaceStore.setCurrentFullUrl(currentFullUrl);
}
